import { type } from "arktype";
export const messageDetailsInviteSchema = type({
    type: "'budget-invite'",
    budgetInviteId: "string",
});
export const messageDetailsInviteResponseSchema = type({
    type: "'budget-invite-response'",
    budgetInviteId: "string",
    accepted: "boolean",
});
/**
 * You lost access to a budget you were editing. Sent so that never happens silently — otherwise the
 * budget simply vanishes from the switcher with no explanation.
 *
 * TWO senders, both on the server: `removeUser` (the owner removed you) and `s_budget.resetBudget` (the
 * owner reset the budget, which deletes the Budget row and cascades every `budget_user` with it). The
 * reason lives in the message TEXT — this shape carries only the budget name, deliberately: it is an
 * arktype `.or()` branch, and that union is one of the three schemas that crash Hermes.
 */
export const messageDetailsBudgetAccessRemovedSchema = type({
    type: "'budget-access-removed'",
    budgetName: "string",
});
// ⚠ This is an arktype `.or()` of OBJECT schemas — one of the three registered schemas that crash Hermes
// at construction, and part of why `arktype` is aliased to a no-op stub on mobile (roo-shared CLAUDE.md
// § "JSONB Runtime Validation"). Adding a branch keeps the existing shape rather than worsening it, but
// do NOT start invoking this schema at runtime in mobile code.
export const messageDetailsSchema = messageDetailsInviteSchema
    .or(messageDetailsInviteResponseSchema)
    .or(messageDetailsBudgetAccessRemovedSchema);
//# sourceMappingURL=message.models.js.map